import { render } from "./NpcTraderButton.vue?vue&type=template&id=76d52f8e"
import script from "./NpcTraderButton.vue?vue&type=script&lang=js"
export * from "./NpcTraderButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/elements/NpcTraderButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76d52f8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76d52f8e', __exports__)) {
    api.reload('76d52f8e', __exports__)
  }
  
  module.hot.accept("./NpcTraderButton.vue?vue&type=template&id=76d52f8e", () => {
    api.rerender('76d52f8e', render)
  })

}


export default __exports__